/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-04-24 12:02:42
 */
import React from 'react'
import styles from './index.module.scss'
import { Popover } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import type { DoneRecord } from './index'

// 状态颜色映射
const colors: Record<number, string> = {
  1: '#EA4D3D',
  2: '#57BE6A',
  3: '#0093FF'
}

// 状态文本映射
const text: Record<number, string> = {
  1: '开票失败',
  2: '已开票',
  3: '开票中',
  5: '已红冲'
}

interface StatusProps {
  record: DoneRecord
}

const Status: React.FC<StatusProps> = ({ record }) => {
  return (
    <>
      <div className={styles.status}>
        <div
          className={styles.icon}
          style={{
            backgroundColor: colors[record.invoiceStatus]
          }}
        ></div>
        {text[record.invoiceStatus]}

        {record.invoiceStatus === 2 && record.invoiceUrl === '' && (
          <Popover
            content={
              <div style={{ width: 296 }}>
                该发票为手动开票，成功开票后将会在7个工作日内发送到您的接收邮箱，请注意查收
              </div>
            }
          >
            <span style={{ marginLeft: 4, cursor: 'pointer' }}>
              <QuestionCircleOutlined />
            </span>
          </Popover>
        )}

        {record.invoiceStatus === 1 && (
          <Popover
            content={
              <div>
                {record.errorMessage || '开票异常，请前往未开票列表重新开票'}
              </div>
            }
          >
            <span style={{ marginLeft: 4, cursor: 'pointer' }}>
              <QuestionCircleOutlined />
            </span>
          </Popover>
        )}
      </div>
    </>
  )
}

export default Status
